import { useNavigate as useReactRouterNavigate } from 'react-router-dom';

/**
 * useNavigate hook - React Router version
 * Returns a navigate function from React Router
 */
function useNavigate() {
	const navigate = useReactRouterNavigate();
	return (path: string) => navigate(path);
}

export default useNavigate;
